export default __webpack_public_path__ + "static/media/3.552cad2d.gif";